<template>
  <div class="strategies-table">
    <v-card-title class="toolbar primary white--text mb-0 pb-3">
      <div>
        <span class="headline">
          <h1 class="headline ml-2">
            <v-icon dark>description</v-icon>
            Tranche Utilizations
          </h1>
        </span>
      </div>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Filter results"
        single-line
        flat
        dark
        color="primary"
        solo-inverted
        hide-details
      />
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :loading="isLoading"
      loading-text="Loading..."
      disable-initial-sort
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td class="">
            {{ props.item.trancheId }}
          </td>
          <td class="">
            <span
              v-if="props.item.trancheName"
            >
              {{ props.item.trancheName }}
            </span>
            <span
              v-else
              class="text--disabled font-italic"
            >
              Not available
            </span>
          </td>
          <td class="">
            {{ props.item.financialProductId }}
          </td>
          <td class="">
            <span
              v-if="props.item.tokenSymbol"
            >
              {{ props.item.tokenSymbol }}
            </span>
            <span
              v-else
              class="text--disabled font-italic"
            >
              Not available
            </span>
          </td>
          <td class="">
            {{ props.item.numberOfInvestors || '-' }}
          </td>
          <td class="">
            {{ props.item.numberOfInvestments || '-' }}
          </td>
          <td class="">
            {{ props.item.existingPieces }}
          </td>
          <td class="">
            {{ props.item.usedPieces }}
          </td>
          <td class="">
            {{ props.item.remainingPieces }}
          </td>
          <td class="">
            <v-progress-linear
              :color="progressColor(props.item)"
              height="5"
              :value="progress(props.item)"
            />
          </td>
          <td class="text-xs">
            <DateDisplay
              :date="(new Date(props.item.lastEventTimestamp)).toISOString()"
              :show-time="true"
            />
          </td>
          <td class="text-xs">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="() => onCalculateTrancheUtilization(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Calculate Manually</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <CalculateTrancheUtilizationDialog
      v-if="isCalculating"
      :is-open="isCalculating"
      :tranche-utilization="currentCalculateTrancheUtilization"
      :toggle-open="toggleCalculating"
    />
  </div>
</template>

<script>
import CalculateTrancheUtilizationDialog from './dialog/CalculateTrancheUtilizationDialog';
import DateDisplay from '@/components/payoutsAndTaxes/payout/shared/DateDisplay';

export default {
  name: 'StrategiesTable',
  components: {
    CalculateTrancheUtilizationDialog,
    DateDisplay,
  },
  data() {
    return {
      isLoading: false,
      isCalculating: false,
      currentCalculateTrancheUtilization: {},
      pagination: {
        rowsPerPage: '40',
        sortBy: 'Last Event Timestamp',
        descending: true,
      },
      search: '',
      headers: [
        { text: 'Tranche ID', value: 'trancheId' },
        { text: 'Tranche Name', value: 'trancheName' },
        { text: 'Financial Product ID', value: 'financialProductId' },
        { text: 'Token Symbol', value: 'tokenSymbol' },
        { text: '#Investors', value: 'numberOfInvestors' },
        { text: '#Investments', value: 'numberOfInvestments' },
        { text: 'Existing pc.', value: 'existingPieces' },
        { text: 'Used pc.', value: 'usedPieces' },
        { text: 'Remaining pc.', value: 'remainingPieces' },
        { text: 'Progress', value: 'progress' },
        { text: 'Last Timestamp', value: 'lastEventTimestamp' },
        { text: 'Actions', value: null, sortable: false },
      ],
    };
  },
  computed: {
    trancheUtilizations() {
      return this.$store.state.strategiesTrancheUtilizationStore.trancheUtilizations;
    },
    filteredItems() {
      const { search } = this;

      return search.length < 1 ?
        this.trancheUtilizations :
        this.trancheUtilizations.filter((item) => {
          let found = false;
          Object.keys(item)
            .map((key) => {
              if (item[key] && String(item[key]).indexOf(search) > -1) {
                found = true;
              }

              return key;
            });

          return found;
        });
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      this.$store.dispatch('fetchStrategiesTrancheUtilizations')
        .finally(() => {
          this.isLoading = false;
        });
    },
    toggleCalculating() {
      this.isCalculating = !this.isCalculating;
      this.currentCalculateTrancheUtilization = {};
    },
    onCalculateTrancheUtilization(trancheUtilization) {
      this.toggleCalculating();
      this.currentCalculateTrancheUtilization = trancheUtilization;
    },
    progress(item) {
      return Math.round(100 / item.existingPieces * item.usedPieces);
    },
    progressColor(item) {
      const progressValue = this.progress(item);
      if (item.existingPieces === 0 || progressValue === 0) {
        return 'grey';
      }
      if (progressValue < 0) {
        return 'error';
      }
      if (progressValue < 50) {
        return 'warning';
      }
      if (progressValue < 90) {
        return 'lime';
      }

      return 'success';
    },
  },
};
</script>
<style lang="scss">
  .bridge-signing-table {
    > .toolbar {
      position: relative;
      padding: 24px 24px 32px 24px;
      margin-bottom: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settlements/StrategiesTrancheUtilizationTable.vue